import { authenticatedFetch } from '@forwardfinancing/component-library';
import { ORIGINATIONS_APP_BASE_URL } from '../constants/global';

export function generateURL(baseUrl, params = {}) {
  let url = baseUrl;

  if (Object.keys(params).length > 0) {
    url += '?';
  }

  // Deletes falsey values from params
  for(const key in params) {
    if(!params[key]) {
      delete params[key];
    }
  }

  let query = Object
    .keys(params)
    .map(key => { return `${key}=${params[key]}`;})
    .join('&');

  return url + query;
}

function isDealRenewal(type) {
  return type === 'Renewal';
}

export function determineDealType(type) {
  if (!isDealRenewal(type) && type !== 'All') {
    return 'New Deal';
  } else if (type !== 'Renewal') {
    return 'all';
  } else {
    return 'Renewal';
  }
}


export function generateKpiParams({startDate, endDate, partner, type}) {
  return {
    start_date: startDate.format('YYYY-MM-DD'),
    end_date: endDate.format('YYYY-MM-DD'),
    deal_type: encodeURIComponent(type),
    ...partner
  };
}

export function fetchKPI({ startDate, endDate, dealType, partner }) {
  const type = determineDealType(dealType);

  const urlBase = `${ORIGINATIONS_APP_BASE_URL()}kpis`;

  const params = generateKpiParams({startDate, endDate, partner, type});

  const request = authenticatedFetch(generateURL(urlBase, params), {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  return request.then(response => {
    if (!response.ok) {
      throw new Error('Unable to fetch Kpi data');
    }

    return response.json();
  });
}
